import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-empty-detail-devis',
    templateUrl: './empty-detail-devis.component.html',
    styleUrls: ['./empty-detail-devis.component.css'],
    standalone: false
})
export class EmptyDetailDevisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
